import { graphql } from '@guuru/graphql-common/gql';

export default graphql(`
  mutation AcceptBotAnswer($id: ID!) {
    acceptBotAnswer(id: $id) {
      id
      status
    }
  }
`);
